import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Set meta tags for 404
    document.title = 'Side ikke fundet - Fryd!';
    
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-8">
      <div className="max-w-2xl text-center">
        <h1 className="text-6xl md:text-8xl font-light text-gray-900 mb-6">
          404
        </h1>
        <h2 className="text-3xl md:text-4xl font-light text-gray-800 mb-6">
          Siden findes ikke
        </h2>
        <p className="text-lg text-gray-600 mb-8 leading-relaxed">
          Den side du leder efter findes ikke længere eller er blevet flyttet.
        </p>
        <p className="text-gray-500 mb-8">
          Du bliver automatisk sendt til forsiden om <span className="font-bold text-gray-900">{countdown}</span> sekunder...
        </p>
        <Link
          to="/"
          className="inline-block px-8 py-3 bg-gray-900 text-white font-light rounded hover:bg-gray-800 transition-colors duration-300"
        >
          Gå til forsiden nu
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
